import { Shield, Gem, Sparkles } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { TFunction } from 'i18next';
import { localizedField } from '@/utils/localizedField';
import type { RewardItem } from '@/services/api/rewards.api';

// Recompensas globales "de tipo conocido": fallback de título/descr./icono por type
// cuando aún no se han rellenado los textos/imagen desde el backoffice.
const TYPE_META: Record<string, { titleKey: string; descKey: string; icon: LucideIcon }> = {
  streak_protector: {
    titleKey: 'rewardsPage.streakProtectorTitle',
    descKey: 'rewardsPage.streakProtectorDesc',
    icon: Shield,
  },
  ai_story: {
    titleKey: 'rewardsPage.aiStoryTitle',
    descKey: 'rewardsPage.aiStoryDesc',
    icon: Sparkles,
  },
};

export function rewardTitle(item: RewardItem, t: TFunction, locale: string): string {
  const localized = localizedField(item, 'title', locale);
  if (localized) return localized;
  const meta = TYPE_META[item.type];
  return meta ? t(meta.titleKey) : item.type;
}

export function rewardDesc(item: RewardItem, t: TFunction, locale: string): string {
  const localized = localizedField(item, 'description', locale);
  if (localized) return localized;
  const meta = TYPE_META[item.type];
  return meta ? t(meta.descKey) : '';
}

/** Imagen subida (hero/miniatura) o null → se usa el icono con borde. */
export function rewardImage(item: RewardItem): string | null {
  return item.imageUrl ?? null;
}

export function rewardIcon(item: RewardItem): LucideIcon {
  return TYPE_META[item.type]?.icon ?? Gem;
}
